import { TableColumnMeta } from "ds/components/Table/types";

export const SESSIONS_COLUMNS_STORAGE_KEY = "organizationSessionsColumnsConfig";

export enum SESSIONS_COLUMN_ID {
  USER = "USER",
  SESSION_ID = "SESSION_ID",
  TYPE = "TYPE",
  IP_ADDRESS = "IP_ADDRESS",
  CREATED_AT = "CREATED_AT",
  EXPIRES_AT = "EXPIRES_AT",
  ACTIONS = "ACTIONS",
}

const MAX_CELL_WIDTH = 2000;

const BASE_COLUMN_META = {
  maxWidth: 400,
  resizable: true,
  allowsSorting: false,
  canHide: false,
  canMove: false,
  canPin: false,
};

export const SESSIONS_COLUMN_CONFIG: Record<SESSIONS_COLUMN_ID, TableColumnMeta> = {
  [SESSIONS_COLUMN_ID.USER]: {
    ...BASE_COLUMN_META,
    id: SESSIONS_COLUMN_ID.USER,
    title: "User",
    minWidth: 150,
    defaultWidth: 260,
    maxWidth: MAX_CELL_WIDTH,
  },
  [SESSIONS_COLUMN_ID.SESSION_ID]: {
    ...BASE_COLUMN_META,
    id: SESSIONS_COLUMN_ID.SESSION_ID,
    title: "Session ID",
    minWidth: 200,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
  },
  [SESSIONS_COLUMN_ID.TYPE]: {
    ...BASE_COLUMN_META,
    id: SESSIONS_COLUMN_ID.TYPE,
    title: "Type",
    minWidth: 100,
    defaultWidth: 140,
  },
  [SESSIONS_COLUMN_ID.IP_ADDRESS]: {
    ...BASE_COLUMN_META,
    id: SESSIONS_COLUMN_ID.IP_ADDRESS,
    title: "IP address",
    minWidth: 120,
    defaultWidth: 160,
  },
  [SESSIONS_COLUMN_ID.CREATED_AT]: {
    ...BASE_COLUMN_META,
    id: SESSIONS_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 120,
    defaultWidth: 180,
  },
  [SESSIONS_COLUMN_ID.EXPIRES_AT]: {
    ...BASE_COLUMN_META,
    id: SESSIONS_COLUMN_ID.EXPIRES_AT,
    title: "Expires at",
    minWidth: 120,
    defaultWidth: 180,
  },
  [SESSIONS_COLUMN_ID.ACTIONS]: {
    ...BASE_COLUMN_META,
    id: SESSIONS_COLUMN_ID.ACTIONS,
    title: "Session actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    resizable: false,
    configurable: false,
  },
};
